<template>
  <tr :data-common-id="booking.common_id" v-if="filterActivity == 0 || filterActivity == booking.trekksoft_activity_id" >
    
    <td v-if="idBus != ''" class="text-center">
      
      <div
        v-if="
          booking.bookingrelbus_set.filter(
            (item) => item.bus_type_rel && item.bus_type_rel.type == path
          ).length != 0
        "
      >
        <div
          v-for="(bus, index) in booking.bookingrelbus_set.filter(
            (item) =>
              item.bus_type_rel.type == path && !item.bus_type_rel.bus_closed
          )"
          :key="index"
        >
          <b-form-checkbox
            v-if="bus.bus_type_rel.id == idBus && bus.bus_type_rel.type == path"
            checked="true"
            @change="assignBus(false, booking.id)"
            class="text-primary"
          ></b-form-checkbox>
          <b-form-checkbox
            v-else
            @change="assignBus(true, booking.id, idBus)"
            readonly="true"
          >
            <i
              v-if="bus.bus_type_rel.bus_closed"
              class="fa fa-lock ml-2"
              title="Bus cerrado"
              style="color: red; font-size: 1rem"
            />
          </b-form-checkbox>
        </div>
      </div>
      <div v-else>
        <b-form-checkbox
          @change="assignBus(true, booking.id, idBus)"
        ></b-form-checkbox>
      </div>
    </td>
    <td
      style="
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 1px;
        white-space: nowrap;
      "
      :title="booking.trekksoft_activity_name"
    >
      {{ booking.customer_name }} <br/> <span style="font-size: 0.8rem;">({{booking.integration}})</span>
    </td>
    <td :data-internal-booking-id="booking.id">
      {{ booking.trekksoft_booking_id }} 
      <br/> 
      <span style="font-size: 0.8rem;">({{booking.id}})</span>
      <span v-if="booking.trekksoft_remarks !== '' && booking.trekksoft_remarks !== null">
        <br/>
        <i class="fa fa-fw fa-2x fa-exclamation-triangle text-warning" title="Esta reserva tiene notas"></i>
        <button v-b-modal="'show_' + booking.id" class="mx-1 border" :variant="'light'">Ver notas</button>
      </span>
      <span v-if="nextIsRelated" class="ml-2">
        <i class="fa fa-arrow-down text-info"></i>
      </span>
      
      <span></span>
    </td>
    <td>{{ booking.trekksoft_hotel_name }}</td>
    <td>{{ booking.trekksoft_hotel_room }}</td>
    <td
      style="
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 1px;
        white-space: nowrap;
      "
      :title="booking.trekksoft_activity_name"
    >
      {{ booking.trekksoft_activity_name }}
    </td>
    <td id="stop_column">
      <div class="d-flex">
        <b-form-select
          @change="assignStop(booking.id, booking.value)"
          v-if="activeOption === 'Activity'"
          v-model="booking.value"
        >
          <optgroup label="Parada seleccionada">
            <option :value="booking.value">
              {{ booking.stop.geo_point.name }}
            </option>
          </optgroup>
          <optgroup label="Paradas cercanas al hotel">
            <option
              v-for="stop in nearbyStops"
              :key="stop.id"
              :label="stop.geo_point.name"
              :value="stop.id"
            >
              {{ stop.geo_point.name }}
            </option>
          </optgroup>
          <!-- .sort((a,b) => a.geo_point.name.toLowerCase() > b.geo_point.name.toLowerCase() ? 1: -1) -->
          <optgroup label="Todas las paradas">
            <option
              v-for="stop in stops"
              :key="stop.id"
              :label="stop.geo_point.name"
              :value="stop.id"
            >
              {{ stop.geo_point.name }}
            </option>
          </optgroup>
        </b-form-select>
        <div v-else>{{ booking.stop.geo_point.name }}</div>
        <!-- check stop -->
        <i
          v-if="check"
          class="fa fa-check-circle text-success"
          :title="
            'La propuesta original y la parada actual coinciden (' +
            currentSelectedStop +
            ')'
          "
        ></i>
        <i
          v-else
          class="fa fa-exclamation-triangle text-warning"
          :title="
            'La propuesta original de parada fue ' +
            (booking.pickup_point_trekk == '' ? '??' : booking.pickup_point_trekk) +
            ' y la actual es ' +
            currentSelectedStop
          "
        ></i>
      </div>
    </td>
    <td>
      <span style="text-transform: uppercase">
        {{ booking.customer_language }}
        <span v-if="booking.customer_language != 'otro'">
          <country-flag
            :country="booking.customer_language"
            size="small"
          />
        </span>
      </span>
    </td>
    <td>{{ booking.customer_adults }}</td>
    <td>{{ booking.customer_children }}</td>
    <td>{{ booking.agency }}</td>
    <td class="text-center" id="checks_column">
      <booking-checks-cell :booking="booking" />
    </td>
    <td>
      <span :title="booking.duration_code != '' && booking.duration_code != null ? booking.duration_name : 'Sin determinar'">
        {{booking.duration_code != "" && booking.duration_code != null ? booking.duration_code : '?'}}
      </span>
    </td>
    <td>
      <div>
        <span v-for="(bus, index) in booking.bookingrelbus_set" :key="index">
          <div
            v-if="bus.bus_type_rel && bus.bus_type_rel.type == path"
            class="align-items"
          >
            <span
              class="badge"
              :style="{
                backgroundColor: bus.bus_type_rel.color_code,
                color: invertHex(bus.bus_type_rel.color_code),
                border: bus.bus_type_rel.bus_closed ? '1px solid black' : ''
              }"
              >
                {{ bus.bus_type_rel.name }} 
                <i
                  v-if="bus.bus_type_rel.bus_closed"
                  class="fa fa-lock ml-2"
                  title="Bus cerrado"
                  style="font-size: 1rem;"
                  :style="{
                    color: invertHex(bus.bus_type_rel.color_code),
                  }"
                />
            </span>

          </div>
        </span>
      </div>
    </td>
    <td>
      <b-dropdown
        dropdown
        variant="link"
        toggle-class="text-decoration-none"
        no-caret
        right
        class="float-right"
        style="position: absolute; right: 0"
      >
        <template v-slot:button-content>
          <i class="fa fa-ellipsis-v"></i>
        </template>
        <b-dropdown-item>
          <div v-b-modal="'show_' + booking.id">
            <i class="fa fa-eye fa-fw"></i> Ver todos los datos
          </div>
          <show-complete-booking-modal :bookingId="booking.id" />
        </b-dropdown-item>
        <b-dropdown-item>
          <div v-b-modal="'edit_' + booking.id">
            <i class="fa fa-pencil fa-fw"></i> Editar reserva
          </div>
          <edit-booking-modal :booking="booking" />
        </b-dropdown-item>
        <b-dropdown-item>
          <div @click="toggleBusService(booking.id, 'pickup')">
            <i class="fa fa-edit fa-fw"></i> Conmutar bus recogida
          </div>
        </b-dropdown-item>
        <b-dropdown-item>
          <div @click="toggleBusService(booking.id, 'excursion')">
            <i class="fa fa-edit fa-fw"></i> Conmutar bus excursión
          </div>
        </b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item
          @click="archive(booking.id)"
          :disabled="booking.bookingrelbus_set != null && booking.bookingrelbus_set.length > 0"
          :title="booking.bookingrelbus_set != null && booking.bookingrelbus_set.length > 0 ? 'Antes de archivar se debe desasignar de cualquier bus' : 'Archivar reserva'"
        >
          <div>
            <i class="fa fa-archive fa-fw"></i> Archivar reserva
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </td>
  </tr>
</template>

<script>
/* eslint-disable */

import utilsColors from "../../../../utils/colors";
import utils from "../../../../utils/utils";
import EditBookingModal from "../Modal/EditBookingModal";
import BookingChecksCell from './BookingChecksCell.vue';
import ShowCompleteBookingModal from "../Modal/ShowCompleteBookingModal";
import OperationMixins from "../../../Mixins/OperationMixins.js";
import { mapGetters } from "vuex";


export default {
    components: {
        EditBookingModal,
        ShowCompleteBookingModal,
        BookingChecksCell
    },
    props: {
        booking: {
            type: Object,
            required: true,
        },
        idBus: {
            type: Number,
            required: true,
        },
        path: {
            type: String,
            required: true,
        },
        stops: {
            type: Array,
            required: true,
        },
        bookings: {
          type: Array,
          required: false
        },
        idx: {
          type: Number,
          required: false
        },
        filterActivity: {
          type: String,
          required: false,
        }
    },
    data: () => {
        return {
            check: false,
            currentStop: "",
            editBookingModalShow: false,
        };
    },
    mixins: [OperationMixins, utilsColors, utils],
    mounted() {
        this.currentSelectedStop;
    },
    computed: {
        ...mapGetters(['activeTab', 'activeOption']),
        currentSelectedStop () {
            this.currentStop = this.booking.stop.geo_point.name
            this.checkStop(this.currentStop, this.booking.pickup_point_trekk)
            return this.currentStop
        },
        nearbyStops () {
            // return stops that are in the same subzone as hotel name
            let list = []
            for ( stop in this.stops ) {
                if ( this.booking.subzone_by_hotel != null && this.stops[stop].geo_point.sub_zone == this.booking.subzone_by_hotel.sub_zone ) {
                    list.push(this.stops[stop])
                }
            }
            return list
        },
        nextIsRelated() {
          if ( this.idx < this.bookings.length-1 && this.bookings[this.idx+1].trekksoft_booking_id == this.booking.trekksoft_booking_id ) {
            return true
          }
          return false
        },
        
    },
    methods: {
        // async assignBus(shouldAssign, resId, busId, loadData = true) {
        //     const bookingData = {
        //         id: resId,
        //         newData: {
        //             bus_type: this.path,
        //         },
        //     };

        //     let action = "assignBus";
        //     shouldAssign
        //         ? (bookingData.newData.bus_id = busId)
        //         : (action = "deassignBus");

        //     try {
        //         await this.$store.dispatch(`bookingsBus/${action}`, bookingData);
        //     } catch (ex) {
        //         this.error = "Failed to load data";
        //     } finally {
        //         // if (loadData) {
        //         // this.$store.dispatch("bookings/loadBookingsByActivity", {
        //         //         date: this.$store.getters.filterDate,
        //         //         group: this.$store.getters.filterGroup,
        //         //         path: this.path,
        //         //     });
        //         // }
        //     }
        // },
        async assignStop(bookingId, stopId) {
            const payload = {
                id: bookingId,
                path: this.path,
                data: {
                    stop_schedule: stopId,
                },
            };
            await this.$store.dispatch("bookingsBus/assignStop", payload);
        },
        checkStop(current, original) {
            if (current != undefined && original != undefined) {
                if (current.toUpperCase() === original.toUpperCase()) {
                    this.check = true;
                    return;
                }
            }
        },
        async toggleBusService(id, service) {
          const payload = {
            id: id,
            service: service
          }
          await this.$store.dispatch("bookings/toggleBusService", payload)
        },
        async archive(bookingId) {
          const payload = {
            id: bookingId
          }
          await this.$store.dispatch("bookings/archive", payload)
        }
    },
}
</script>



<style scoped>
p.activity-name {
    margin-bottom: 0rem;
}
#stop_column i {
  font-size: 14px;
  margin-left: 2px;
}
</style>
